import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { WaitlistDialog } from "./WaitlistDialog";
import { Mail, Facebook, Instagram, Youtube } from "lucide-react";
import { SHOPIFY_URL } from "../lib/config";

export const Footer = () => {
  return (
    <footer className="bg-forest text-ivory/90 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <span className="inline-flex bg-ivory rounded-2xl p-4 mb-5 shadow-sm">
            <img src="/brand/logo-full.webp" alt="Laura Combs Productions, LLC" className="h-28 w-auto" loading="lazy" decoding="async" />
          </span>
          <p className="text-ivory/70 text-sm leading-relaxed max-w-xs">
            Building stronger lives through books, education, practical tools, and
            compassionate guidance.
          </p>
        </div>
        <div>
          <h4 className="text-gold text-sm uppercase tracking-widest mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li><a href={SHOPIFY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">Shop</a></li>
            <li><Link to="/resources" className="hover:text-gold transition-colors">Resources</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors">Blog</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">About Laura</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            <li><Link to="/account" className="hover:text-gold transition-colors">My Account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-gold text-sm uppercase tracking-widest mb-4">Follow Laura</h4>
          <ul className="space-y-3 text-sm text-ivory/80">
            <li>
              <a href="https://www.facebook.com/LauraCombsProductions" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="social-facebook">
                <Facebook className="w-4 h-4" /> Facebook
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/lauracombsproductions/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="social-instagram">
                <Instagram className="w-4 h-4" /> Instagram
              </a>
            </li>
            <li>
              <span className="flex items-center gap-3 text-ivory/40 cursor-default" data-testid="social-youtube">
                <Youtube className="w-4 h-4" /> YouTube
                <span className="text-[0.65rem] uppercase tracking-wide text-gold/70">Coming Soon</span>
              </span>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-gold text-sm uppercase tracking-widest mb-4">Stay Rooted</h4>
          <p className="text-ivory/70 text-sm leading-relaxed mb-5">
            Join the Laura Combs Productions community for book launches, practical resources,
            inspiration, and exclusive updates.
          </p>
          <WaitlistDialog source="footer">
            <Button className="rounded-full bg-gold hover:bg-gold/90 text-forest px-6 gap-2 transition-colors" data-testid="footer-join-btn">
              <Mail className="w-4 h-4" /> Join the Community
            </Button>
          </WaitlistDialog>
        </div>
      </div>
      <div className="border-t border-ivory/15">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-ivory/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Laura Combs Productions, LLC. All rights reserved.</span>
          <span>Calm confidence. Wisdom. Growth.</span>
        </div>
      </div>
    </footer>
  );
};
